import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import MountCustom from '../MountCustom'; 





const Hook = () => {
  const [action, setAction] = useState("Document Preparation"); 
  const navigate = useNavigate(); 


  const handleHomeClick = () => {
    navigate('/home'); 
  };

  const handleDocumentPreparationClick = () => {
    setAction("Document Preparation"); 
  };

  const handleConfidenceClick = () => {
    setAction("Confidence"); 
  };
  
  const isPrerendering = typeof window === 'undefined' || window.__PRERENDERING;
  if (typeof window === 'undefined' || isPrerendering) {
    return isPrerendering ? <div id="prerender-placeholder"></div> : null;
  }

  
  

  return (
    <div className="setter">
      <Helmet>
        <title>
          {action === "Document Preparation" ? "Document Preparation" : "Administrative Hearings"} | Contranorm Media & Production
        </title>

        <meta 
          name="description" 
          content="Take personalized support services to a whole new level with your very own client advocate and professional document preparation." 
        />
        <meta name="robots" content="index, follow" />
        <meta 
          name="keywords" 
          content="document preparation, administrative hearings, client advocacy, Contranorm Media, professional writing"
        />
        <link rel="canonical" href="https://contranormdigital.com/hook" />
      </Helmet>
      
      <MountCustom>
        <div className="page">
          <h1>
            <div className="redRock">{action === "Document Preparation" ? "Document Preparation" : "Administrative Hearings"}</div>
          </h1>
          
          <h3>{action === "Document Preparation" ? "Need Help Preparing for Your Case?" : "File Your Papework With Confidence"}</h3>
        
          <div className="underline"></div>
        
          {action === "Document Preparation" ? ( 
            
            <>
           
              <p>
                If you are involved in an unresolved workplace grievance or dispute, you may be eligible to have an administrative judge hear your case. Attend any administrative hearing with confidence, knowing that every document that you've submitted has been meticulously prepared. With Contranorm Media & Production's document preparation service, we don't just help you submit your paperwork—we craft comprehensive arguments to validate your evidence and fortify your case.
              </p>
            </>
            
          ) : (
            <>
            
              <p>
                Preparing legal documents can be challenging, but it doesn't have to be. Let our team help you get your pleading filed quickly and accurately, so you can focus on winning your case.

                Our expert writers and client advocates specialize in administrative processes from formal grievances to EEOC complaints, MSPB appeals, PFR, and Petitions for Enforcement.  So if you are a federal, state, or private- sector employee, we're here to help you leverage your legal protections, so you can secure a more positive outcome.</p>

              

     


          
            </>
          )}

          

          <div className="link-with-text">
            Learn to&nbsp;
            <Link to="/articles" >manage</Link>
            &nbsp;your own administrative filings.
          </div>
        
          <div className="submit-container">
            {action === "Document Preparation" ? (
              <>
                 <Link to="/price-calculator" className="submit gray">Get Started</Link>
                <div className="submit" onClick={handleConfidenceClick}>Learn More</div> 
              </>
            ) : (
              <>
                <Link to="/price-calculator" className="submit gray">Get Started</Link> 
                <Link to="/hookb" className="submit">Learn More</Link> 
              </>
            )}
          </div>
        </div>
      </MountCustom>
    </div>
  );
};

export default Hook;
